export var CounterBadgeSize = {
  SMALL: 'small',
  REGULAR: 'regular',
  LARGE: 'large'
};
export var CounterBadgeVariant = {
  DESTRUCTIVE: 'destructive',
  BLACK: 'black'
};